import { create } from 'zustand'

type useDropdownZIndexStoreState = {
    current: number
    getNext: () => number
}

export const useDropdownZIndexStore = create<useDropdownZIndexStoreState>(
    (set, get) => ({
        current: 1000,
        getNext: () => {
            const next = get().current + 1
            set({ current: next })
            return next
        },
    })
)
